import { listMethod } from "./resource";
const resource = "addresses";
export const list = (client, request) => listMethod({ resource, client })(request);
